import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Sentry } from './lib/sentry';
import { isPublicDomain } from './utils/domain';
import PublicRouter from './routers/PublicRouter';
import AppRouter from './routers/AppRouter';

function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-8">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Something went wrong</h1>
        <p className="text-gray-600 mb-4">We've been notified and are working on a fix.</p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}

function App() {
  const pathname = window.location.pathname;
  
  // Dev preview: /public-preview/* always uses PublicRouter (for Lovable editor testing)
  const isPublicPreview = pathname.startsWith('/public-preview');
  const isPublic = isPublicPreview || isPublicDomain() || pathname.startsWith('/m/');

  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <React.StrictMode>
        <div className="App">
          <Toaster
            position="bottom-center"
            richColors
            closeButton
            theme="light"
          />
          <BrowserRouter basename={isPublicPreview ? '/public-preview' : undefined}>
            {isPublic ? <PublicRouter /> : <AppRouter />}
          </BrowserRouter>
        </div>
      </React.StrictMode>
    </Sentry.ErrorBoundary>
  );
}

export default App;
